/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AccidentTypeApi} from '../api/accidenttype.api';
import { switchMap, map } from 'rxjs/operators';
import { AccidentTypeData,AccidentType  } from '../../../interfaces/masters/accidenttype';

@Injectable()
export class AccidentTypeService extends AccidentTypeData {

  constructor(private api: AccidentTypeApi) {
    super();
  }


  list(): Observable<AccidentType[]> {
    return this.api.list();
  }

  getById(url:string): Observable<AccidentType>{
      return this.api.getById(url);
  }

  create(url: string, data:AccidentType): Observable<AccidentType> {
    return this.api.add(url,data);
  }

  update(url: string, data:AccidentType): Observable<AccidentType> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
